import { FormControlProps } from '../../interfaces/FormControlProps';
import { InputState } from '../Input';
import { PropertyHelpers } from '../../helpers/PropertyHelpers';
import { FormConfigHelpers } from './FormConfigHelpers';
import { ParameterMappingsHelper } from './ParameterMappingsHelper';
import { MaskedInputState } from '../MaskedInput';
import { FormikHelpers } from './FormikHelpers';
import { FormControlHelpers } from './FormControlHelpers';
import { FormFieldStateHelpers } from './FormFieldStateHelpers';
import { KenticoValidatorUtils } from "../../kentico/KenticoUtils";
import { FormService } from "../../services/FormService";
import { ReactFormHelpers } from '../../containers/helpers/FormHelpers';
import { DatasourceLoaderStateService } from '../../services/DatasourceLoaderStateService';

export class AjaxCallHelpers {

    // TODO : replace "any" in React.Component<FormControlProps, any> with 
    //        InputState|MaskedInputState and make "yarn test"(jest) work with that
    static getRelatedData(
        component: React.Component<FormControlProps, any>,
        input: string = ''
    ) {
        function isCurrentField(fieldName: string) {
            return fieldName === component.props.formFieldDefinition.name;
        }

        function areAllValid(parameters: any[]) {
            return parameters.reduce((isValid, fieldMapping) => {
                if (FormFieldStateHelpers.isTouchedHasErrors(component, fieldMapping.field)){
                    // tslint:disable-next-line
                    console.log(fieldMapping.field + ' Is invalid' );
                }
                let checkValid = true;
                if (!!component.props.formFieldDefinition.datasoureRequiresAllFieldsFilled) {
                    if ((component.props.form.values[fieldMapping.field] || "").trim() === "") {
                        checkValid = false;
                    }
                }
                return (
                    checkValid &&
                    isValid &&
                    // No errors
                    !FormFieldStateHelpers.isTouchedHasErrors(component, fieldMapping.field)
                );
            }, true);
        }
        if (PropertyHelpers.hasRelatedDataUrl(component.props)) {                    

            const requiredParameters = ParameterMappingsHelper.parameterMappings(component);
            let doRunDatasource : boolean = true;
            const parameters = requiredParameters.reduce((result: string[], fieldMapping: any) => {
                // Get value
                let fieldValue = FormikHelpers.getValue(component, fieldMapping.field);
                if (fieldValue && fieldValue.value) {
                    fieldValue = fieldValue.value;
                }

                // check optional datasourceConditions
                if (component.props.formFieldDefinition.datasourceConditions !== undefined) {
                    if (!component.props.formFieldDefinition.datasourceConditions.kenticoMacroFunction(
                            (component as any).props.formController.form.fieldMapper, 
                            fieldValue, 
                            KenticoValidatorUtils)) {
                        doRunDatasource = false;
                    }
                }
                
                

                // Build parameters
                if (isCurrentField(fieldMapping.field) && ((input != '') || ((input as any).value))) {
                    let isFound = false;
                    component.props.formConfig.formSteps.map((formName) => {
                        const formDefinitions = component.props.formController.props.formDefinitions;
                        formDefinitions[formName].map((formDef : any) => {
                            if (!isFound && formDef.name == fieldMapping.field) {
                                input = ReactFormHelpers.getValueForFormDefinition(input as any, formDef);
                                isFound = true;
                            }
                        });
                    });

                    if ((input as any).value) {
                        result.push(`${fieldMapping.mapsTo}=${(input as any).value}&`);
                    } else {
                        result.push(`${fieldMapping.mapsTo}=${input}&`);
                    }
                } else if (fieldValue !== '') {
                    let isFound = false;
                    component.props.formConfig.formSteps.map((formName) => {
                        const formDefinitions = component.props.formController.props.formDefinitions;
                        formDefinitions[formName].map((formDef : any) => {
                            if (!isFound && formDef.name == fieldMapping.field) {
                                fieldValue = ReactFormHelpers.getValueForFormDefinition(fieldValue as any, formDef);
                                isFound = true;
                            }
                        });
                    });

                    result.push(`${fieldMapping.mapsTo}=${fieldValue}&`);
                }
                return result;
            }, []);

            if (!doRunDatasource) {
                return;
            }

            if (requiredParameters.length >= parameters.length && areAllValid(requiredParameters)) {
                // Clear destination fields
                FormikHelpers.mapEmptyToFields(component);

                // Get time delay and counter
                let timeDelay = FormControlHelpers.getTimeDelay(component);
                let counter = FormControlHelpers.getCounter(component); // keep track of latest request

                // Execute Ajax call
                let timer = setTimeout(() => {
                    const _parameters = `?${parameters.join('')}`;
                    if (PropertyHelpers.isActionUrl(component.props)) {
                        component.props.formConfig.actions[component.props.formConfig.urlMappingsRelatedData[component.props.formFieldDefinition.datasource].substring(7)](
                            component.props.formikBag.values, 
                            component.props.formikBag);
                    } else {
                        DatasourceLoaderStateService.increaseLoadingCounter();
                        $.ajax({
                            url: PropertyHelpers.getRelatedDataUrl(component.props, _parameters)
                        })
                        .done(data => {
                            DatasourceLoaderStateService.decreaseLoadingCounter();

                            if (component.props.formController.unmounted) {
                                return;
                            }
                            if ((component as any).unmounted !== undefined && !!(component as any).unmounted) {
                                return;
                            }
                            component.setState({ isLoading: false } , () => {                                
                                // Needed to prevent unwanted updates based on parallel calls
                                if (counter < component.state.dataSourceCounter) {
                                    return;
                                }
                                if (component.props.formController.unmounted) {
                                    return;
                                }
                                if ((component as any).unmounted !== undefined && !!(component as any).unmounted) {
                                    return;
                                }
                                FormikHelpers.mapValuesToFields(component, data);  
                                FormService.callFormRelatedDataCallback(component.props.formFieldDefinition.datasource, 
                                    component.props.formController.props.formName,
                                    data);
                                component.props.formController.setPayload(data);
                            });
                        })
                        .fail(() => {
                            DatasourceLoaderStateService.resetLoadingCounter();
                            if (component.props.formController.unmounted) {
                                return;
                            }
                            if ((component as any).unmounted !== undefined && !!(component as any).unmounted) {
                                return;
                            }
                            component.setState({ isLoading: false, isErrorLoading : true } , () => {                                
                                // true => error
                                FormikHelpers.mapEmptyToFields(component, true);
                            });
                        });
                    }
                }, timeDelay);

                component.setState({ dataSourceCounter: counter, timer: timer, isLoading: true, isErrorLoading: false });
            }
        }
    }

    static setDatasource(component: React.Component<FormControlProps, InputState>) {
        FormConfigHelpers.outputMappings(component, (fieldMapping: any) => {
            component.props.formikBag.setFieldValue(fieldMapping.mapsTo, '');
            component.props.formikBag.setFieldValue('error-' + fieldMapping.mapsTo, false);
        });
    }

    static triggerDatasource(formikBag: any, formConfig : any, datasource: string) {
    
        if (formConfig.urlMappingsRelatedData &&
            formConfig.urlMappingsRelatedData[datasource]) {
                const requiredParameters = ParameterMappingsHelper.parameterMappingsViaDatasource(formConfig, datasource);
                const parameters = requiredParameters.reduce((result: string[], fieldMapping: any) => {
                    // Get value
                    let fieldValue = formikBag.values[fieldMapping.field];
                                    
                    if (fieldValue !== '') {
                        result.push(`${fieldMapping.mapsTo}=${fieldValue}&`);
                    }
                    return result;
                }, []);

                if (requiredParameters.length == parameters.length) {
                    const _parameters = `?${parameters.join('&')}`;
                        $.ajax({
                            url: formConfig.urlMappingsRelatedData[datasource] + _parameters
                        })
                        .done(data => {
                            formConfig.outputMappings[datasource].map((fieldMapping) => {
                                formikBag.setFieldValue(
                                    fieldMapping.mapsTo,
                                    data[fieldMapping.field]
                                );
                
                                if (data[fieldMapping.field] != '') {
                                    formikBag.setFieldValue(
                                        'error-' + fieldMapping.mapsTo,
                                        false
                                    );
                                } else {
                                    formikBag.setFieldValue(
                                        'error-' + fieldMapping.mapsTo,
                                        true
                                    );
                                }
                            });
                        })
                        .fail(() => {
                            // true => error
                            formConfig.outputMappings[datasource].map((fieldMapping) => {
                                formikBag.setFieldValue(fieldMapping.mapsTo, '');
                                formikBag.setFieldValue(
                                    'error-' + fieldMapping.mapsTo,
                                    true
                                );
                            });
                        });
                }
        }

    }
}
